// https://github.com/chrisdickinson/raf/blob/master/index.js
var now = Date.now();
var vendors = ["moz", "webkit"];
var suffix = "AnimationFrame";
var raf = window["request" + suffix];
var caf = window["cancel" + suffix] || window["cancelRequest" + suffix];

for (var i = 0; !raf && i < vendors.length; i += 1) {
  raf = window[vendors[i] + "Request" + suffix];
  caf = window[vendors[i] + "Cancel" + suffix] || window[vendors[i] + "CancelRequest" + suffix];
} // Some versions of FF have rAF but not cAF


if (!raf || !caf) {
  var last_1 = 0;
  var id_1 = 0; // @ts-ignore: Unreachable code error

  var queue_1 = [any];
  var frameDuration_1 = 1000 / 60; // @ts-ignore: Unreachable code error

  raf = function rafFn(callback) {
    if (queue_1.length === 0) {
      // @ts-ignore: Unreachable code error
      var rafNow = now();
      var next = Math.max(0, frameDuration_1 - (rafNow - last_1));
      last_1 = next + rafNow;
      setTimeout(function () {
        // @ts-ignore: Unreachable code error
        var cp = queue_1.slice(0); // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue

        queue_1.length = 0; // @ts-ignore: Unreachable code warn

        for (var _i = 0, cp_1 = cp; _i < cp_1.length; _i++) {
          var cpItem = cp_1[_i];

          if (!cpItem.cancelled) {
            try {
              cpItem.callback(last_1);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }

    queue_1.push({
      handle: id_1 += 1,
      callback: callback,
      cancelled: false
    });
    return id_1;
  }; // @ts-ignore: Unreachable code error


  caf = function cafFn(handle) {
    for (var _i = 0, queue_2 = queue_1; _i < queue_2.length; _i++) {
      var queueItem = queue_2[_i];

      if (queueItem.handle === handle) {
        // @ts-ignore: Unreachable code error
        queueItem.cancelled = true;
      }
    } //
    // for (let i = 0; i < queue.length; i += 1) {
    //   // @ts-ignore: Unreachable code error
    //   if (queue[i].handle === handle) {
    //     // @ts-ignore: Unreachable code error
    //     queue[i].cancelled = true;
    //   }
    // }

  };
} // @ts-ignore: Unreachable code error


function newFn(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(window, fn);
} // @ts-ignore: Unreachable code error


newFn.cancel = function cancelFn() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  caf.apply(window, args);
};

export default newFn;